import designTokens from '@customink/design-tokens/build/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiTextField: {
            defaultProps: {
                size: 'small',
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    marginTop: theme.spacing(0.165),
                    '&.Mui-error': {
                        borderColor: designTokens.color.status.error,
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginTop: theme.spacing(0.5),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=textFieldTheme.js.map